import Vue from 'vue';
import { ContentfulLink } from '@/@types/member';

interface Data {
  linkClickTracker: boolean[];
  isAllLinksClicked: boolean;
}

export default Vue.extend({
  data(): Data {
    return {
      linkClickTracker: [],
      isAllLinksClicked: false,
    };
  },
  methods: {
    setLinksClickTrackerFunctionality(linksDiv: string): void {
      // clear tracker
      this.linkClickTracker = [];
      // loop through all links that must be clicked
      const trackedLinks = document.querySelectorAll(`#${linksDiv} a`);
      trackedLinks.forEach((link, index) => {
        // set link as unclicked (false) in a tracking array of booleans
        this.linkClickTracker.push(false);
        // add a click listener
        link.addEventListener('click', () => {
          // set link as clicked (true) in tracking array
          this.linkClickTracker[index] = true;
          // set whether or not all links have been clicked
          this.isAllLinksClicked = this.linkClickTracker.every((element) => {
            return element === true;
          });
        });
      });
    },
    // Will take contentful link and return back { target, href, text, hidden } to be used in template as:
    // <div v-if="!link.hidden">
    //   <router-link :to="{ name: link.href }" v-if="link.target === 'route'">
    //     {{ link.text | t }}
    //   </router-link>
    //   <a :href="link.href" v-else :target="link.target">
    //     {{ link.text | t }}
    //   </a>
    // </div>
    parseContentfulLink(linkContentField): ContentfulLink {
      let regex;
      const link = linkContentField.actionValue;
      const config = {
        target: '',
        href: '',
        text: linkContentField.actionDescription,
        hidden: linkContentField.hidden || false,
      };
      if (link.indexOf('route="') > -1) {
        config.target = 'route';
        regex = /(route=")(.*)(")/g;
      } else if (link.indexOf('link="') > -1) {
        config.target = '_blank';
        regex = /(link=")(.*)(")/g;
      } else if (link.indexOf('link:self="') > -1) {
        config.target = '_self';
        regex = /(link:self=")(.*)(")/g;
      }
      config.href = link.replace(regex, (match, a, b) => {
        return b;
      });
      return config;
    },
  },
});
